import React, { ReactElement } from 'react';
import { mapIriToSekciaPredpisu, reformatIri } from 'slovlex-idsk-react-components';
import { Text, Button, ModalDialogue } from 'idsk-react-components';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import PredpisSearchModalComponent from '../../../../PredpisSearchModalComponent/PredpisSearchModalComponent';
import Definicia from '../../../../../model/Definicia';
import iconSourceAdd from '../../../../../../assets/images/icon-source-add.svg';
import iconSourceDelete from '../../../../../../assets/images/icon-source-delete.svg';
import { useClient } from '../../../../../context/ClientStatusContext';
import { fetchPredpis } from '../../../../../client/external/indexer/predpisClient';
import { Predpis } from '../../../../../model/indexer/Predpis';
import { useSecurityContext } from '../../../../../context/SecurityContext';

interface Props {
  setItemList: (data: Definicia[]) => void;
  setDefinicia;
  itemId: number;
  itemList: Array<Definicia>;
  definicia: Definicia;
}

const VybratPredpis = ({
  setItemList,
  setDefinicia,
  itemId,
  itemList = [],
  definicia,
}: Props): ReactElement => {
  const {
    wrapClient: fetchPredpisClient,
  } = useClient(fetchPredpis);

  const updateVybranyPredpis = async (_: string, url: string): Promise<void> => {
    const { cesta, iri } = reformatIri(url);
    const { data } = await fetchPredpisClient(iriToCislo(iri));
    const popis = buildPopis(data, cesta, iri);
    updateValues(url, popis);

    window.parent.postMessage(
      {
        type: 'iframe-to-parent-modal-dialogue-close',
      },
      '*',
    );
  };

  const updateValues = (zdroj: string, popisLegislativnehoZdroja: string): void => {
    setDefinicia(prevState => ({ ...prevState, zdroj, popisLegislativnehoZdroja }));
    const newFormValues = [...itemList];
    newFormValues[itemId] = { ...definicia, zdroj, popisLegislativnehoZdroja };
    setItemList(newFormValues);
  };

  const iriToCislo = (iri: string): string => {
    const parts = iri.split('/');
    return `${parts[4]}/${parts[3]}`;
  };
  const buildPopis = (
    predpis: Predpis,
    cesta: string,
    iri: string,
  ): string => `${predpis.cislo} ${mapIriToSekciaPredpisu(cesta, iri)} - ${predpis.nazov}`;

  const { accessToken, organizationId } = useSecurityContext();
  const headers = {
    ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    ...(organizationId && { OrganizationId: encodeURIComponent(organizationId) }),
  };

  if (definicia.zdroj && definicia.popisLegislativnehoZdroja) {
    return (
      <>
        <Text>{definicia.popisLegislativnehoZdroja}</Text>
        <Button
          size="large"
          buttonStyle="third"
          iconBefore={iconSourceDelete}
          onClick={() => {
            updateValues(undefined, undefined);
          }}
        >
          Zmazať predpis ako zdroj
        </Button>
      </>
    );
  }

  return (
    <ModalDialogue
      title=""
      openModalDialogueBtn={(
        <Button
          size="large"
          buttonStyle="third"
          iconBefore={iconSourceAdd}
          onClick={() => {
            window.parent.postMessage({
              type: 'iframe-to-parent-modal-dialogue-open',
            }, '*');
          }}
        >
          Vybrať právny predpis ako zdroj
        </Button>
        )}
    >
      <HelmetProvider>
        <Helmet>
          <script src={`${process.env.REACT_APP_SUBPATH}js/jquery.min.js`} type="application/javascript" />
        </Helmet>
        <PredpisSearchModalComponent setUpdateVybranyPredpis={updateVybranyPredpis} headers={headers} />
      </HelmetProvider>
    </ModalDialogue>
  );
};

export default VybratPredpis;
